export function noteFromContent(content, tags) {
    const title = extractTitle(content);
    const creationTime = Date.now();
    return {
        id: BigInt(0),
        title,
        content,
        createdAt: creationTime,
        updatedAt: creationTime,
        tags,
    };
}
export async function serialize(note, cryptoService) {
    const serializableNote = {
        title: note.title,
        content: note.content,
        createdAt: note.createdAt,
        updatedAt: note.updatedAt,
        tags: note.tags,
    };
    const encryptedNote = await cryptoService.encrypt(JSON.stringify(serializableNote));
    return {
        id: note.id,
        encrypted_text: encryptedNote,
    };
}
export async function deserialize(enote, cryptoService) {
    const serializedNote = await cryptoService.decrypt(enote.encrypted_text);
    const deserializedNote = JSON.parse(serializedNote);
    return Object.assign({ id: enote.id }, deserializedNote);
}
export function summarize(note, maxLength = 50) {
    const div = document.createElement('div');
    div.innerHTML = note.content;
    let text = div.innerText;
    const title = extractTitleFromDomEl(div);
    if (title) {
        text = text.replace(title, '');
    }
    return text.slice(0, maxLength) + (text.length > maxLength ? '...' : '');
}
function extractTitleFromDomEl(el) {
    var _a;
    const title = el.querySelector('h1');
    if (title) {
        return title.innerText;
    }
    const blockElements = el.querySelectorAll('h1,h2,p,li');
    for (const el of blockElements) {
        if (((_a = el.innerText) === null || _a === void 0 ? void 0 : _a.trim().length) > 0) {
            return el.innerText.trim();
        }
    }
    return '';
}
export function extractTitle(html) {
    const div = document.createElement('div');
    div.innerHTML = html;
    return extractTitleFromDomEl(div);
}
